import { h } from 'preact';

export const StepCounter = (props) => {
  return (
    <div className={'step-count'}>
      <p>Question {props.currentStep} of {props.totalSteps}</p>
    </div>
  );
}
